import { HTML_LINK_TARGET } from '../../../constants/html'
import { getQaSelector } from '../../../utils/common'
import { Link } from '../../Link'

import { QA_NAME_GRETA_AI_CHAT_MARKDOWN_LINK } from './GretaAIChatMarkdownLink.constants'

import * as styles from './GretaAIChatMarkdownLink.module.css'

function GretaAIChatMarkdownLink({ children, href }) {
  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_MARKDOWN_LINK })

  return (
    <Link
      {...qaProps}
      className={styles.link}
      rel='noopener noreferrer'
      target={HTML_LINK_TARGET.blank}
      to={href}
    >
      {children}
    </Link>
  )
}

export default GretaAIChatMarkdownLink
